import React from 'react';
import { firstNameFirst, formatPhoneNumber } from "../../../helpers/formatting";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export default class Prescriber extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.Prescriber.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { containerClass, prescriberName, contactNumber } = this.props;
        return (
            <div className={containerClass}>
                <h4 className="h5">Prescribed by:</h4>
                {prescriberName ? firstNameFirst(prescriberName) : '-'}
                {contactNumber &&
                    <a className="phone-link" href={"tel:" + contactNumber}>
                        <div className="pharmacy-tile__phone details-icon-prepend">
                            <div className="icon-col">
                                <span className="icon-phone" />
                            </div>
                            <div className="details-col">
                                {formatPhoneNumber(contactNumber)}
                            </div>
                        </div>
                    </a>
                }
            </div>
        );
    }
}